import React from 'react';

export default class Footer extends React.Component {
    render() {
        return (
            <div class="bg-gray-200 text-center footer h-auto grid grid-rows-4 p-4 xl:grid-cols-4 xl:grid-rows-1 xl:pr-64 xl:pl-64 xl:text-xl">
                <a href="https://organic-naturetea.com/" class="xl:text-right">蟬吃茶</a>
                <font>電話：886-2-27322745</font>
                <font>Line bot ID： ＠lgr7235d</font>
                <a href="https://line.me/R/ti/p/Ndtea3GYpS" class="text-blue-600 xl:text-left xl:pl-4">加入好友</a>
            </div>
        )
    }
}